import { memo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { linkType, SidebarLinkProps } from '../types';

import SidebarLinkButton from './SidebarLinkButton';

const SidebarLink = ({ to, title, onClick, dataLocator, type, target = '_self', icon }: SidebarLinkProps) => {
    const handleClick = () => onClick && onClick(to);
    const { pathname } = useLocation();

    const isActive = pathname === to;
    const isPrimary = linkType.Primary === type;

    const linkProps = {
        'data-locator': dataLocator,
        'data-testid': dataLocator,
        onClick: handleClick,
        target,
    };

    const commonButtonProps = {
        isActive,
        isPrimary,
        title,
        icon,
    };

    return (
        <NavLink to={to} {...linkProps}>
            <SidebarLinkButton {...commonButtonProps} />
        </NavLink>
    );
};

export default memo(SidebarLink);
